import { atom } from 'jotai';
import { atomWithLoadable } from 'lib/atoms';
import request from 'lib/request';
import type { SubtractsMissingTirsResponse } from './types';

export const pageAtom = atom(1);
export const pageSizeAtom = atom(100);

const fetchPage = async (page: number, pageSize: number) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  const response = await request.get<SubtractsMissingTirsResponse>(
    `/admin/subtracts_missing_tirs?${params.toString()}`
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
};

export const [subtractsMissingTirsAtom, subtractsMissingTirsLoadableAtom] =
  atomWithLoadable((get) => {
    const page = get(pageAtom);
    const pageSize = get(pageSizeAtom);
    return fetchPage(page, pageSize);
  });
